import React from 'react';
import {CMSLandingHtml} from '@tempo/landing';
import {Box, Button} from '@tempo/core';
import Link from 'next/link';
import {useResolveTranslations} from '../hooks/useResolveTranslations';
import sanitizeHtml from 'sanitize-html';

type StrapiHtmlBlockProps = {
	strapiBlockData: any;
	translationNamespace: string;
};

export const StrapiHtmlBlock: React.FC<StrapiHtmlBlockProps> = ({
	strapiBlockData,
	translationNamespace,
}) => {
	const resolve = useResolveTranslations(translationNamespace);
	return (
		<Box bg="background.neutral.primary.default" py="spacing.3xl" w="100%">
			<Box maxWidth={{base: '100%', md: '1440px'}} mx="auto">
				<CMSLandingHtml
					title={resolve(strapiBlockData.title).replace(/<[^>]+>/g, '')}
					cta={
						strapiBlockData.cta ? (
							<Button as={Link} href={strapiBlockData.cta?.href}>
								{resolve(strapiBlockData.cta?.label)}
							</Button>
						) : undefined
					}
					htmlContent={resolve(
						sanitizeHtml(strapiBlockData.content, {
							allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img']),
						}),
					)}
				/>
			</Box>
		</Box>
	);
};
